import { RemoteGetAllPersonValidatedActivities } from 'data/usecases';
import { GetAllPersonValidatedActivitiesUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPersonValidatedActivities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPersonValidatedActivities =
  (): GetAllPersonValidatedActivitiesUseCaseInterface =>
    new RemoteGetAllPersonValidatedActivities(
      makeApiUrlPersonValidatedActivities(),
      makeAxiosHttpClient(),
    );
